// @ts-nocheck
import { useCallback, useState } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../../const/ApiEndPoints';

export default function useEntity() {
  const [allModelList, setAllModelList] = useState([]);

  /**
   * readAll api
   * @param {Object} body - Request body parameters.
   * @param {boolean} [body.is_minimal=false] - Return only a few fields of the entity if true.
   */
  const getAllModelEntity = useCallback((body, loader = false) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.READ_ALL_MODEL_ENTITY}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        setAllModelList(res?.data?.modelEntity);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  /**
   * Fetch entities.
   *
   * This API supports two query patterns:
   *
   * 1. Pass both `template_id` and `version_id`
   *    → Fetch entities for a specific template version.
   *
   * 2. Pass `entity_type` and `request_type`
   *    → Fetch entities based on type and request category.
   *
   * @param {string} [body.template_id] - UUID of the template.
   * @param {string} [body.version_id] - UUID of the version.
   * @param {string} [body.entity_type] - Type of entity.
   * @param {string} [body.request_type] - Type of request.
   * @param {boolean} [loader=true] - Controls global loader visibility. Pass false to suppress the global loader.
   */
  const getAllModelEntityLite = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.LITE_READ_ALL_MODEL_ENTITY}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getEntityStatuses = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ENTITY_STATUSES}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const createModelFirstStep = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CREATE_MODEL_ENTITY_FIRST_STEP}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const archiveEntity = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ARCHIVE_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createModelSecondStep = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CREATE_MODEL_ENTITY_SECOND_STEP}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createModelThirdStep = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CREATE_MODEL_ENTITY_THIRD_STEP}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createModelForthStep = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CREATE_MODEL_ENTITY_FORTH_STEP}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const deleteModelEntity = (body) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DELETE_ENTITY}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSingleEntityDetails = useCallback((body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_SINGLE_ENTITY}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const updateModelEntity = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.UPDATE_MODEL}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const isEntityAvailable = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.MODEL_AVAILABLE}`,

        { params, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const integrateEntity = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.NUI.INTEGRATE_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getSearchList = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.FULL_SEARCH}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const downloadEntitiesReport = (body, loader = true) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNLOAD_REPORT_ENTITIES}`,
        body,
        {
          loader,
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const linkedEntities = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.LINKED_ENTITIES}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  /** Saves linked column preferences with the root entity in query params. */
  const updateLinkedEntitiesColumnConfig = (entityId, body) => {
    return axios.post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.LINKED_ENTITIES_COLUMN_CONFIG}`,
      body,
      {
        params: {
          entity_id: entityId,
        },
        loader: false,
      }
    );
  };

  const getLinkedTemplateEntities = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_LINKED_TEMPLATE_ENTITIES}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getEntityAttributeKeysList = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ATTRIBUTE_LIST_KEYS}`,
        { params: body, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const postAllModelEntityLite = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.LITE_READ_ALL_MODEL_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getEntityAttributeValuesList = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ATTRIBUTE_LIST_VALUES}`,
        { params: body, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getEntityMetaData = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.META_DATA}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateBulkQueries = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.BULK_UPDATE.BULK_UPDATE_ATTRIBUTES}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getBedrockOptionList = useCallback(() => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.BEDROCK_OPTION_LIST}`,
        { loader: false }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getAllArtifactsList = useCallback(({ entityId } = {}) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ALL_ARTIFACTS_LIST}`,
        {
          params: { entityId },
          loader: false,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    getAllModelEntity,
    allModelList,
    setAllModelList,
    createModelThirdStep,
    createModelForthStep,
    createModelSecondStep,
    createModelFirstStep,
    deleteModelEntity,
    getSingleEntityDetails,
    updateModelEntity,
    isEntityAvailable,
    integrateEntity,
    getSearchList,
    archiveEntity,
    downloadEntitiesReport,
    getEntityStatuses,
    linkedEntities,
    updateLinkedEntitiesColumnConfig,
    getLinkedTemplateEntities,
    getAllModelEntityLite,
    postAllModelEntityLite,
    getEntityAttributeKeysList,
    getEntityAttributeValuesList,
    getEntityMetaData,
    updateBulkQueries,
    getBedrockOptionList,
    getAllArtifactsList,
  };
}
